import React, { useState, useEffect } from "react";
import {
  Table,
  Th,
  Td,
  DataStatus,
  TdFixed,
  // InputQtyDecimal,
  ThFixed,
  Tr,
  THead,
  TBody,
  ActionButton,
  SelectSearch,
  CreateButton,
  UpdateButton,
  DeleteButton,
  // NumberFormat,
} from "components";
import { useLocation } from "react-router-dom";
import { Formik, useFormikContext } from "formik";

import { SubKegiatanApi } from "api";
import * as Yup from "yup";
import { ButtonGroup } from "react-bootstrap";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import { DecimalConvert, RupiahConvert } from "utilities";
import Axios from "axios";

export const TableAsetSection = ({ dropdown, type, tabType, data }) => {
  const location = useLocation();
  const [update, setUpdate] = useState("");
  const { values, setValues } = useFormikContext();
  const checkKeyTab =
    tabType === "material"
      ? "detailMaterial"
      : tabType === "manusia"
      ? "detailManusia"
      : tabType === "peralatan"
      ? "detailPeralatan"
      : tabType === "overhead"
      ? "detailOverhead"
      : "detailLainnya";

  const TableForm = ({ data }) => {
    const [dropdownAset, setDropdownAset] = useState({
      kategori: [],
      jenis: [],
      item: [],
    });
    const [isGrupAsetChange, setIsGrupAsetChange] = useState({
      loading: false,
      disable: true,
    });
    const [isKategoriAsetChange, setIsKategoriAsetChange] = useState({
      loading: false,
      disable: true,
    });
    const [isJenisAsetChange, setIsJenisAsetChange] = useState({
      loading: false,
      disable: true,
    });

    const mappingDropdownAset = (data, keyValue, keyLabel, keySatuan) =>
      data.length > 0 &&
      data.map((val) => ({
        value: val[keyValue],
        label: val[keyLabel],
        namaSatuan: val[keySatuan] ?? undefined,
      }));

    const onGrupAsetChange = (id) => {
      setIsGrupAsetChange({ loading: true, disable: true });
      Axios.all([SubKegiatanApi.dropdownKategoriAset({ id_grup_aset: id })])
        .then(
          Axios.spread(({ data }) => {
            setDropdownAset({
              ...dropdownAset,
              kategori: mappingDropdownAset(
                data?.data ?? [],
                "id_kategori_aset",
                "nama_kategori_aset"
              ),
            });
          })
        )
        .finally(() => setIsGrupAsetChange({ loading: false, disable: false }));
    };

    const onKategoriAsetChange = (id) => {
      setIsKategoriAsetChange({ loading: true, disable: true });
      Axios.all([SubKegiatanApi.dropdownJenisAset({ id_kategori_aset: id })])
        .then(
          Axios.spread(({ data }) => {
            setDropdownAset({
              ...dropdownAset,
              jenis: mappingDropdownAset(
                data?.data ?? [],
                "id_jenis_aset",
                "nama_jenis_aset"
              ),
            });
          })
        )
        .finally(() =>
          setIsKategoriAsetChange({ loading: false, disable: false })
        );
    };

    const onJenisAsetChange = (id) => {
      setIsJenisAsetChange({ loading: true, disable: true });
      Axios.all([SubKegiatanApi.dropdownItemAset({ id_jenis_aset: id })])
        .then(
          Axios.spread(({ data }) => {
            setDropdownAset({
              ...dropdownAset,
              item: mappingDropdownAset(
                data?.data ?? [],
                "id_item_aset",
                "nama_item_aset",
                "nama_satuan"
              ),
            });
          })
        )
        .finally(() =>
          setIsJenisAsetChange({ loading: false, disable: false })
        );
    };

    const tableFormIntialValues = {
      idGrupAset: data?.idGrupAset ?? null,
      namaGrupAset: data?.namaGrupAset ?? null,
      idKategoriAset: data?.idKategoriAset ?? null,
      namaKategoriAset: data?.namaKategoriAset ?? null,
      idJenisAset: data?.idJenisAset ?? null,
      namajenisAset: data?.namajenisAset ?? null,
      idItemSumberDaya: data?.idItemSumberDaya ?? null,
      namaItemSumberDaya: data?.namaItemSumberDaya ?? null,
      namaSatuan: data?.namaSatuan ?? null,
      idSatuan: data?.idSatuan ?? null,
      qty: parseFloat(data?.qty ?? 0),
      idSumberPengadaan: data?.idSumberPengadaan ?? null,
      namaSumberPengadaan: data?.namaSumberPengadaan ?? null,
      hargaSatuan: parseFloat(data?.hargaSatuan ?? 0),
    };
    const tableValidationSchema = Yup.object().shape({
      idGrupAset: Yup.string().required("Pilih grup").nullable(),
      idKategoriAset: Yup.string().required("Pilih kategori").nullable(),
      idJenisAset: Yup.string().required("Pilih jenis").nullable(),
      qty: Yup.string().required("Masukan qty").nullable(),
      idItemSumberDaya: Yup.string()
        .required("Pilih item sumber daya")
        .nullable(),
      idSumberPengadaan: Yup.string()
        .required("Pilih item sumber pengadaan")
        .nullable(),
      hargaSatuan: Yup.string().required("Masukan harga satuan").nullable(),
    });

    const setSubmitHandler = (value, key) => {
      if (data) {
        setValues({
          ...values,
          subKegiatan: {
            ...values.subKegiatan,
            [key]: values?.subKegiatan?.[key].map((val, index) =>
              update === index ? value : val
            ),
          },
        });
        setUpdate(undefined);
      }
      if (!data) {
        setValues({
          ...values,
          subKegiatan: {
            ...values?.subKegiatan,
            [key]: [value, ...values?.subKegiatan?.[key]],
          },
        });
      }
    };
    const tableSubmitHandler = (value) => {
      tabType === "material" && setSubmitHandler(value, "detailMaterial");
      tabType === "manusia" && setSubmitHandler(value, "detailManusia");
      tabType === "peralatan" && setSubmitHandler(value, "detailPeralatan");
      tabType === "overhead" && setSubmitHandler(value, "detailOverhead");
      tabType === "lainnya" && setSubmitHandler(value, "detailLainnya");
    };

    return (
      <Formik
        enableReinitialize
        initialValues={tableFormIntialValues}
        validationSchema={tableValidationSchema}
        onSubmit={tableSubmitHandler}
      >
        {({ values, setValues, errors, touched, handleSubmit }) => (
          <Tr>
            <Td colSpan="2">
              <SelectSearch
                placeholder="Pilih grup aset"
                option={dropdown?.grupAset}
                defaultValue={{
                  value: values.idGrupAset ?? "",
                  label: values.namaGrupAset ?? "Pilih grup aset",
                }}
                onChange={(val) => {
                  onGrupAsetChange(val.value);
                  setValues({
                    ...values,
                    idGrupAset: val.value,
                    namaGrupAset: val.label,
                  });
                }}
                error={Boolean(errors.idGrupAset) && touched.idGrupAset}
                errorText={
                  Boolean(errors.idGrupAset) &&
                  touched.idGrupAset &&
                  errors.idGrupAset
                }
              />
            </Td>
            <Td>
              <SelectSearch
                placeholder="Pilih kategori aset"
                option={dropdownAset?.kategori}
                loading={isGrupAsetChange.loading}
                isDisabled={isGrupAsetChange.disable}
                defaultValue={{
                  value: values.idKategoriAset ?? "",
                  label: values.namaKategoriAset ?? "Pilih kategori aset",
                }}
                onChange={(val) => {
                  onKategoriAsetChange(val.value);
                  setValues({
                    ...values,
                    idKategoriAset: val.value,
                    namaKategoriAset: val.label,
                  });
                }}
                error={Boolean(errors.idKategoriAset) && touched.idKategoriAset}
                errorText={
                  Boolean(errors.idKategoriAset) &&
                  touched.idKategoriAset &&
                  errors.idKategoriAset
                }
              />
            </Td>
            <Td>
              <SelectSearch
                placeholder="Pilih jenis aset"
                option={dropdownAset?.jenis}
                defaultValue={{
                  value: values.idJenisAset ?? "",
                  label: values.namajenisAset ?? "Pilih jenis aset",
                }}
                isDisabled={isKategoriAsetChange.disable}
                loading={isKategoriAsetChange.loading}
                onChange={(val) => {
                  onJenisAsetChange(val.value);
                  setValues({
                    ...values,
                    idJenisAset: val.value,
                    namajenisAset: val.label,
                  });
                }}
                error={Boolean(errors.idJenisAset) && touched.idJenisAset}
                errorText={
                  Boolean(errors.idJenisAset) &&
                  touched.idJenisAset &&
                  errors.idJenisAset
                }
              />
            </Td>
            <Td>
              <SelectSearch
                placeholder="Pilih item sumber daya"
                option={dropdownAset?.item}
                isDisabled={isJenisAsetChange.disable}
                loading={isJenisAsetChange.loading}
                defaultValue={{
                  value: values.idItemSumberDaya ?? "",
                  label: values.namaItemSumberDaya ?? "Pilih item convert",
                }}
                onChange={(val) => {
                  setValues({
                    ...values,
                    idItemSumberDaya: val.value,
                    namaItemSumberDaya: val.label,
                    namaSatuan: val.namaSatuan,
                  });
                }}
                error={
                  Boolean(errors.idItemSumberDaya) && touched.idItemSumberDaya
                }
                errorText={
                  Boolean(errors.idItemSumberDaya) &&
                  touched.idItemSumberDaya &&
                  errors.idItemSumberDaya
                }
              />
            </Td>
            <Td>{values?.namaSatuan ?? "-"}</Td>
            <Td>
              <SelectSearch
                placeholder="Pilih sumber pengadaan"
                option={dropdown?.sumberPengadaan}
                defaultValue={{
                  value: values.idSumberPengadaan ?? "",
                  label: values.namaSumberPengadaan ?? "Pilih item convert",
                }}
                onChange={(val) => {
                  setValues({
                    ...values,
                    idSumberPengadaan: val.value,
                    namaSumberPengadaan: val.label,
                  });
                }}
                error={
                  Boolean(errors.idSumberPengadaan) && touched.idSumberPengadaan
                }
                errorText={
                  Boolean(errors.idSumberPengadaan) &&
                  touched.idSumberPengadaan &&
                  errors.idSumberPengadaan
                }
              />
            </Td>
            <Td>
              {/* <InputQtyDecimal
                placeholder="Masukan qty"
                value={values?.qty ?? null}
                onChange={(e) => setValues({ ...values, qty: e })}
                error={Boolean(errors.qty) && touched.qty}
                errorText={Boolean(errors.qty) && touched.qty && errors.qty}
              /> */}
            </Td>
            <Td>
              {/* <NumberFormat
                placeholder="Masukan harga satuan"
                value={values?.hargaSatuan}
                decimalSeparator=","
                onChange={(e) => setValues({ ...values, hargaSatuan: e })}
                error={Boolean(errors.hargaSatuan) && touched.hargaSatuan}
                errorText={
                  Boolean(errors.hargaSatuan) &&
                  touched.hargaSatuan &&
                  errors.hargaSatuan
                }
              /> */}
            </Td>
            <Td>
              {
                RupiahConvert(
                  String(
                    parseFloat(values.hargaSatuan ?? 0) *
                      parseFloat(values.qty ?? 0)
                  )
                ).getWithComa
              }
            </Td>
            <TdFixed>
              {data ? (
                <>
                  <ButtonGroup>
                    <ActionButton
                      text={<AiOutlineCheck />}
                      variant="success"
                      onClick={handleSubmit}
                      size="sm"
                    />
                    <ActionButton
                      text={<AiOutlineClose />}
                      variant="danger"
                      onClick={() => setUpdate(undefined)}
                      size="sm"
                    />
                  </ButtonGroup>
                </>
              ) : (
                <CreateButton
                  noText
                  icon
                  className="px-4"
                  onClick={handleSubmit}
                  size="sm"
                />
              )}
            </TdFixed>
          </Tr>
        )}
      </Formik>
    );
  };

  return (
    <>
      <Table>
        <THead>
          <Tr>
            <Th>No</Th>
            <Th>Grup Aset</Th>
            <Th>Kategori Aset</Th>
            <Th>Jenis Aset</Th>
            <Th>Item Peralatan</Th>
            <Th>Satuan</Th>
            <Th>Sumber Pengadaan</Th>
            <Th>Qty.</Th>
            <Th>Harga Satuan</Th>
            <Th>Sub Total</Th>
            {type !== "read" && <ThFixed>Aksi</ThFixed>}
          </Tr>
        </THead>
        <TBody>
          {type !== "read" && <TableForm />}
          {data.length > 0 ? (
            data.map((val, index) =>
              update === index ? (
                <TableForm data={val} />
              ) : (
                <Tr key={index}>
                  <TdFixed>{index + 1}</TdFixed>
                  <Td>{val.namaGrupAset ?? "-"}</Td>
                  <Td>{val.namaKategoriAset ?? "-"}</Td>
                  <Td>{val.namaJenisAset ?? "-"}</Td>
                  <Td>{val.namaItemSumberDaya ?? "-"}</Td>
                  <Td>{val.namaSatuan ?? "-"}</Td>
                  <Td>{val.namaSumberPengadaan ?? "-"}</Td>
                  <Td>
                    {DecimalConvert(parseFloat(val.qty ?? 0)).getWithComa}
                  </Td>
                  <Td>
                    {
                      RupiahConvert(parseFloat(val.hargaSatuan ?? 0).toString())
                        .getWithComa
                    }
                  </Td>
                  <Td>
                    {
                      RupiahConvert(
                        String(
                          parseFloat(val.hargaSatuan ?? 0) *
                            parseFloat(val.qty ?? 0)
                        )
                      ).getWithComa
                    }
                  </Td>

                  {type !== "read" && (
                    <TdFixed>
                      <ButtonGroup>
                        <UpdateButton
                          noText
                          icon
                          variant="success"
                          onClick={() => setUpdate(index)}
                          size="sm"
                        />
                        <DeleteButton
                          noText
                          icon
                          onClick={() => {
                            const filterData = values.subKegiatan?.[
                              checkKeyTab
                            ]?.filter((res, ind) => ind !== index);

                            setValues({
                              ...values,
                              subKegiatan: {
                                ...values?.subKegiatan,
                                [checkKeyTab]: filterData,
                              },
                            });
                          }}
                          size="sm"
                        />
                      </ButtonGroup>
                    </TdFixed>
                  )}
                </Tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="11">
                <DataStatus text="Tidak ada data" />
              </td>
            </tr>
          )}
        </TBody>
      </Table>
    </>
  );
};
